<h2 mat-dialog-title>Upload File</h2><br>
<mat-dialog-content>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Target Path</mat-label>
    <input matInput [(ngModel)]="targetPath" placeholder="/home/hh/">
  </mat-form-field>
  <input type="file" (change)="onFileSelected($event)" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="uploading">Cancel</button>
  <button mat-raised-button color="primary" (click)="onUpload()" [disabled]="!selectedFile || !targetPath || uploading">Upload</button>
</mat-dialog-actions>
